import EventBus, { EventName } from '../../../../Shared/Assets/event-bus';
import {empty} from '../../../../Shared/Assets/utils';

export default class DealerCallbackForm {
  constructor() {
    this.eventBus = new EventBus();
  }

  init(dealerCallbackForm) {
    this.form = dealerCallbackForm;
    this.formElement = dealerCallbackForm.get(0);
    this.form.on('submit', this._handleRequestCallbackFormSubmit);

    this._initPostDealerCallbackEventListener();
    this._initSearchQuery();
  }

  _initPostDealerCallbackEventListener = () => {
    this.eventBus.handle(EventName.DealerCallbackFormSubmitted, this._handleCallbackFormSubmitted);
  }

  _handleRequestCallbackFormSubmit = (evt) => {
    evt.preventDefault();

    let form = evt.target;
    if (!$(form).valid()) return;

    if (form.SkipCollectingFraudnet.value.toUpperCase() !== "TRUE") {
      this._populateFraudNetInfo(evt.target);
    }

    this._sendEnquiry(evt.target);

    return false;
  }

  _initSearchQuery = () => {
    let networkId = this.formElement.NetworkId.value;
    if (sessionStorage) {
      var lastSearch = sessionStorage.getItem(networkId);
      if (!empty(lastSearch) && lastSearch != "null") {
        this.formElement.SearchQuery.value = lastSearch;
      }
    }
  }

  _populateFraudNetInfo = (form) => {
    if (!empty(userdata)) {
      let fraudNetInfoControlId = $(form).find("[dataFraudnet]").attr("id");
      if (fraudNetInfoControlId !== null)
        userdata.p_data(fraudNetInfoControlId);
    }
  }

  _sendEnquiry = (form) => {
    let url = form.action;

    if (typeof csn !== "undefined" && !empty(csn.baseUrl)) {
      url = csn.baseUrl + url;
    }

    let $form = $(form);
    this._showLoading($form);
    this._hideErrorSummary();
    let $this = this;

    $.ajax({
      url: url,
      type: "POST",
      data: $form.serialize(),
      dataType: "json",
      success: response => {
        $this._hideLoading($form);

        // fire event to show message on all callback forms
        $this.eventBus.dispatch(EventName.DealerCallbackFormSubmitted, response);
      },
      error: errorDetail => {
        $this._hideLoading($form);
        $this._showErrorSummary(errorDetail);
      }
    });
  }

  _showLoading = ($form) => {
    $($form.find("button[type='submit'],input[type='submit']"))
      .addClass('loading')
      .prop("disabled", true);
  }

  _hideLoading = ($form) => {
    $($form.find("button[type='submit'],input[type='submit']"))
      .removeClass('loading')
      .prop("disabled", false);
  }

  _hideErrorSummary = () => {
    let errorDisplayElement = this.form.find(".error-message-block");
    if (!errorDisplayElement || !errorDisplayElement.length) {
      return;
    }

    errorDisplayElement.html("").hide();
  }

  _showErrorSummary = (error) => {
    let errorDisplayElement = this.form.find(".error-message-block");
    if (!errorDisplayElement || !errorDisplayElement.length) {
      // no error display element found, display in console
      console.log(error);
      return;
    }

    if (error.responseJSON && error.responseJSON.errors && Array.isArray(error.responseJSON.errors)) {
      let errorMessage = error.responseJSON.errors.map(function (err) {
        return err.message;
      }).join(", ");

      errorDisplayElement
        .text(errorMessage)
        .show();
      return;
    }

    errorDisplayElement
      .html("Oops! Your callback request has failed to send. <a href='javascript: window.location.reload()'>Click here</a> to refresh the page and try again.")
      .show()
      ;
  }

  _handleCallbackFormSubmitted = (response) => {
    if (!empty(response.contentHtml)) {
      $(this.form).parents(".dealer-call-back-form")
        .empty()
        .append(response.contentHtml);
    }
  }
}